import {scopedHandler} from 'utils/redux';
import ns from './namespace';
import initState from './state';
import * as actions from './actions';
import * as effects from './effects';
import {decorateHandler as lifecycle} from 'fragments/lifecycle';

const handler = scopedHandler(ns, (state = initState, fullState, {type, payload}) => {
	switch (type) {
		case actions.initialize.type: {
			return [
				{
					...state,
					initialized: true,
				},
				effects.initialize(),
			];
		}

		case actions.destroy.type: {
			return [initState, null];
		}

		case actions.getDashboard.type: {
			return [
				{
					...state,
					processing: true,
				},
				effects.getDashboard(payload),
			];
		}

		case actions._getDashboard.type: {
			return [
				{
					...state,
					processing: false,
					dashboard: payload,
				},
				null,
			];
		}

		case actions.getTeams.type: {
			return [state, effects.getTeams(payload)];
		}
		case actions._getTeams.type: {
			return [
				{
					...state,
					teams: payload,
				},
				null,
			];
		}

		case actions._getUnacknowledgedVisitsCount.type: {
			return [
				{
					...state,
					unacknowledgedVisitsCount: payload,
				},
			];
		}

		default:
			return [state, null];
	}
});

export default lifecycle({
	namespace: ns,
	initializeType: actions.initialize.type,
	destroyType: actions.destroy.type,
})(handler);
